import React, { useLayoutEffect, useState } from 'react';
import { WMSTileLayer, WMSTileLayerProps } from 'react-leaflet';

export interface HideableWMSTileLayerProps extends WMSTileLayerProps {
  visible: boolean;
  time: string;
}

export const HideableWMSTileLayer: React.FunctionComponent<HideableWMSTileLayerProps> = ({
  visible,
  ...rest
}) => {
  const [ref, setRef] = useState<WMSTileLayer | null>(null);
  const container = ref?.leafletElement?.getContainer();
  useLayoutEffect(() => {
    if (!container) return;
    container.style.display = visible ? 'block' : 'none';
  }, [container, visible]);

  return <WMSTileLayer ref={setRef} {...rest} />;
};
